import { useTranslation } from 'react-i18next';
// assets
import facebookIcon from './facebook-red-circle.svg';
import twitterIcon from './twitter-red-circle.svg';
import redditIcon from './reddit-red-circle.svg';
import emailIcon from './email-red-circle.svg';

interface SharingProps {
  url: string;
  twitterText: string;
  emailBody: string;
  emailSubject: string;
  onShare?: (platform: string) => void;
  className?: string;
}

function Sharing({
  url,
  twitterText,
  emailBody,
  emailSubject,
  className,
  onShare = (): void => {},
}: SharingProps): JSX.Element {
  const { t } = useTranslation();
  function onClickFacebook(): void {
    const encodedUrl = encodeURIComponent(url);

    window.open(
      `http://www.facebook.com/sharer.php?u=${encodedUrl}`,
      'sharer',
      'toolbar=0,status=0,width=550,height=325'
    );

    onShare('facebook');
  }

  return (
    <div className={`sharing ${className || ''}`}>
      <span className="cta">{t('sharing.share')}</span>
      <a className="item --facebook" onClick={onClickFacebook} data-sharing-facebook />
      <a
        className="item --twitter"
        href={`https://twitter.com/intent/tweet?&text=${twitterText}`}
        onClick={(): void => {
          onShare('twitter');
        }}
        data-sharing-twitter
        data-testid="twitter"
      />
      <a
        className="item --reddit"
        href={`//www.reddit.com/submit?url=${encodeURIComponent(url)}`}
        target="_blank"
        aria-label={t('accessibility.newWindow')}
        onClick={(): void => {
          onShare('reddit');
        }}
        data-sharing-reddit
      />
      <a
        className="item --email"
        href={`mailto:?subject=${emailSubject}&body=${emailBody}`}
        onClick={(): void => {
          onShare('email');
        }}
        data-sharing-email
      />
      <style jsx>
        {`
          .sharing {
            display: flex;
            align-items: center;
          }

          .cta {
            color: $darkgrey;
            font-size: 14px;
            margin-right: 7px;
          }

          .item {
            display: block;
            height: 24px;
            width: 24px;
            margin-right: 5px;
            cursor: pointer;
            background-repeat: no-repeat;
          }

          .item.--facebook {
            background-image: url(${facebookIcon});
            background-size: 24px 24px;
          }

          .item.--twitter {
            background-image: url(${twitterIcon});
            background-size: 24px 24px;
          }

          .item.--reddit {
            background-size: 24px 24px;
            background-image: url(${redditIcon});
          }

          .item.--email {
            background-size: 24px 24px;
            background-image: url(${emailIcon});
          }

          @media (max-width: 355px) {
            .item {
              height: 20px;
              width: 20px;
              margin-right: 3px;
            }

            .item.--facebook {
              background-image: url(${facebookIcon});
              background-size: 20px 20px;
            }

            .item.--twitter {
              background-image: url(${twitterIcon});
              background-size: 20px 20px;
            }

            .item.--reddit {
              background-size: 20px 20px;
              background-image: url(${redditIcon});
            }

            .item.--email {
              background-size: 20px 20px;
              background-image: url(${emailIcon});
            }
          }
        `}
      </style>
    </div>
  );
}

export default Sharing;
